module.exports = __webpack_public_path__ + "static/media/HIIT.7efc41f1.webp";